export default {
  clear: 'form/clear',
};
